export function normalizeAnnotationPages(annotations, maxPageIndex) {
  const fixedAnnotations = []
  const normalizedAnnotations = annotations.map((annotation) => {
    if (annotation.pageIndex >= 0 && annotation.pageIndex <= maxPageIndex) {
      return annotation
    }
    const fixedAnnotation = { ...annotation, pageIndex: 0 }
    fixedAnnotations.push(fixedAnnotation)
    return fixedAnnotation
  })
  return { annotations: normalizedAnnotations, fixedAnnotations }
}
